export default __webpack_public_path__ + "static/media/cho_thue_xe_co_taigia_re_tphcm.12455eba.svg";